import React from "react";
import { Check, UserRound } from "lucide-react";

/** "SMITH, Jane Anne", "JANE SMITH" or "Mrs Jane Smith" → "Jane Smith"-style; already-tidy names pass through. */
export function tidyName(raw) {
  let n = (raw || "").trim();
  if (n.includes(",")) { const [last, first] = n.split(",", 2); n = `${first.trim()} ${last.trim()}`; }
  n = n.replace(/^(mr|mrs|ms|miss|mx|dr|sir|dame|lord|lady|prof)\.?\s+/i, "");
  return n === n.toUpperCase() ? n.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase()) : n;
}

/** Companies House roles → the role lists on our forms. */
export function roleFor(role) {
  const r = (role || "").toLowerCase();
  if (r.includes("secretary")) return "Company Secretary";
  if (r.includes("director")) return "Director";
  if (r.includes("member") || r.includes("partner")) return "Owner";
  return "";
}

/** The picked company's directors, one tap each — whoever is filling the form is usually one of them. */
export function DirectorPick({ directors, value, onPick, title = "Is this you?", note, dark = false, testId = "director", className = "" }) {
  const all = (directors || []).filter((d) => d.name);
  // directors first — they're who applies; secretaries and others after
  const people = [...all].sort((a, b) => /director/i.test(b.role || "") - /director/i.test(a.role || "")).slice(0, 6);
  const more = all.length - people.length;
  if (!people.length) return null;
  const box = dark ? "border-white/10 bg-white/[0.04]" : "border-[#0055FF]/15 bg-[#0055FF]/[0.04]";
  return (
    <div className={`rounded-2xl border p-3.5 animate-in fade-in-0 slide-in-from-top-1 duration-200 ${box} ${className}`} data-testid={`${testId}-pick`}>
      <div className={`flex items-center gap-1.5 text-[12.5px] font-semibold ${dark ? "text-slate-100" : "text-slate-700"}`}>
        <UserRound className={`size-3.5 ${dark ? "text-[#7da9ff]" : "text-[#0055FF]"}`} /> {title}
      </div>
      <div className="mt-2 flex flex-wrap gap-2">
        {people.map((d, i) => {
          const name = tidyName(d.name);
          const on = (value || "").trim() === name;
          const idle = dark ? "bg-white/[0.06] border-white/15 text-slate-100 hover:border-[#7da9ff]/60"
            : "bg-white border-slate-200 text-slate-800 hover:border-[#0055FF]/50";
          return (
            <button key={i} type="button" onClick={() => onPick(name, d)} data-testid={`${testId}-${i}`}
                    className={`inline-flex items-center gap-2 h-9 px-3.5 rounded-full border text-[13px] font-semibold transition-[background-color,border-color,transform] duration-150 active:scale-[.97] ${
                      on ? "bg-[#0055FF] border-[#0055FF] text-white" : idle}`}>
              {on && <Check className="size-3.5" strokeWidth={3} />}
              {name}
              {d.role && <span className={`text-[11px] font-medium ${on ? "text-white/80" : dark ? "text-slate-400" : "text-slate-400"}`}>{d.role}</span>}
            </button>
          );
        })}
      </div>
      <div className={`mt-2 text-[11.5px] ${dark ? "text-slate-400" : "text-slate-500"}`}>
        {note || "From Connexis search. Someone else? Just type the name below."}
        {more > 0 && ` ${more} more found — type the name if yours isn't here.`}
      </div>
    </div>
  );
}

export default DirectorPick;
